module.exports = __webpack_public_path__ + "static/media/POS-Media_Code_of_Conduct.cce75de0.pdf";